import React from 'react';
import Styled from './Rewards.style';
import { Button, Icon, Input } from '../../components/index';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Col, Row } from 'react-styled-flexboxgrid';
import { useTranslation } from 'react-i18next';
import store from 'store2';
interface TaskFormProps {
  isDesktop: boolean;
  postLeakRepairSignup: Function;
  challengeTag?: any;
  icon?: any;
  title?: any;
  description?: any;
  closeDescription?: any;
  closeTitle?: any;
  leakFixSignup?: any;
  formElements?: any;
  id?: any;
  tag?: string;
  buttonText: string;
}

const TaskForm: React.FC<TaskFormProps> = (props) => {
  const { postLeakRepairSignup, leakFixSignup, isDesktop, tag } = props;
  const [t] = useTranslation('common');
  const propertyId = store('property');
  const bonusTaskSignup = leakFixSignup;
  console.log(tag);

  const renderFormElements = () => {
    const SignUpSchema = Yup.object().shape({
      name: Yup.string().when([], {
        is: () =>
          props.formElements['form-elements'] &&
          props.formElements['form-elements'].name,
        then: Yup.string()
          .required(`${t('portal.general_form_errors.required')}`)
          .min(1, 'Name is too few characters'),
        otherwise: Yup.string(),
      }),
      contactNumber: Yup.string().when([], {
        is: () =>
          props.formElements['form-elements'] &&
          props.formElements['form-elements'].telephone,
        then: Yup.string()
          .matches(
            /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?#(\d{4}|\d{3}))?$/,
            `${t('portal.general_form_errors.contact_not_valid')}`,
          )
          .required(`${t('portal.general_form_errors.required')}`),
        otherwise: Yup.string().matches(
          /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?#(\d{4}|\d{3}))?$/,
          `${t('portal.general_form_errors.contact_not_valid')}`,
        ),
      }),
      houseNumber: Yup.string().when([], {
        is: () =>
          props.formElements['form-elements'] &&
          props.formElements['form-elements'].houseNumber,
        then: Yup.string()
          .min(1, `${t('portal.general_form_errors.house_number_not_valid')}`)
          .required(`${t('portal.general_form_errors.required')}`),
        otherwise: Yup.string(),
      }),
      street: Yup.string().when([], {
        is: () =>
          props.formElements['form-elements'] &&
          props.formElements['form-elements'].street,
        then: Yup.string()
          .min(1, `${t('portal.general_form_errors.street_not_valid')}`)
          .required(`${t('portal.general_form_errors.required')}`),
        otherwise: Yup.string(),
      }),
    });
    return (
      <>
        <Icon size={isDesktop ? 100 : 75} icon={props.icon} />
        {bonusTaskSignup !== undefined ? (
          <>
            <Styled.Wrap style={{ width: isDesktop ? 500 : '100%' }}>
              <Styled.SlideTitle>
                {t(props.formElements.closeTitle)}
              </Styled.SlideTitle>
              <Styled.SlideDescription
                style={{ fontSize: isDesktop ? '16px' : '14px' }}
              >
                {t(props.formElements.closeDescription)}
              </Styled.SlideDescription>
            </Styled.Wrap>
            <Button
              onClick={() => {
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              }}
            >
              CLOSE
            </Button>
          </>
        ) : (
          <>
            <Styled.Wrap style={{ width: isDesktop ? 500 : '100%' }}>
              {props.formElements.title && (
                <Styled.SlideTitle>
                  {t(props.formElements.title)}
                </Styled.SlideTitle>
              )}{' '}
              <Styled.SlideDescription
                style={{ fontSize: isDesktop ? '16px' : '14px' }}
              >
                {t(props.formElements.description)}{' '}
              </Styled.SlideDescription>
              <Formik
                initialValues={{
                  id: props.id,
                  property_id: propertyId,
                  tag: props.tag,
                  name: '',
                  contactNumber: '',
                  houseNumber: '',
                  street: '',
                }}
                validationSchema={SignUpSchema}
                onSubmit={(values, { setSubmitting }) => {
                  postLeakRepairSignup(
                    values,
                    props.tag,
                    props.id,
                    parseInt(propertyId),
                    setSubmitting(false),
                  );
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  /* and other goodies */
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Row>
                      <Col xs={12} sm={12}>
                        <div>
                          {props.formElements['form-elements'] &&
                          props.formElements['form-elements'].name ? (
                            <div>
                              <Input
                                type="text"
                                id="name"
                                label={`${t(
                                  props.formElements['form-elements'].name.text,
                                )}`}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.name}
                              />
                              <Styled.Error>
                                {errors.name && touched.name && errors.name}
                              </Styled.Error>
                            </div>
                          ) : null}
                          {props.formElements['form-elements'] &&
                          props.formElements['form-elements'].telephone ? (
                            <div>
                              <Input
                                type="text"
                                id="contactNumber"
                                label={`${t(
                                  props.formElements['form-elements'].telephone
                                    .text,
                                )}`}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.contactNumber}
                              />
                              <Styled.Error>
                                {errors.contactNumber &&
                                  touched.contactNumber &&
                                  errors.contactNumber}
                              </Styled.Error>
                            </div>
                          ) : null}
                          {props.formElements['form-elements'] &&
                          props.formElements['form-elements'].houseNumber ? (
                            <div>
                              <Input
                                type="text"
                                id="houseNumber"
                                label={`${t(
                                  props.formElements['form-elements']
                                    .houseNumber.text,
                                )}`}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.houseNumber}
                              />
                              <Styled.Error>
                                {errors.houseNumber &&
                                  touched.houseNumber &&
                                  errors.houseNumber}
                              </Styled.Error>
                            </div>
                          ) : null}
                          {props.formElements['form-elements'] &&
                          props.formElements['form-elements'].street ? (
                            <div>
                              <Input
                                type="text"
                                id="street"
                                label={`${t(
                                  props.formElements['form-elements'].street
                                    .text,
                                )}`}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.street}
                              />
                              <div>
                                {errors.street &&
                                  touched.street &&
                                  errors.street}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    {props.formElements['form-elements'] &&
                    props.formElements['form-elements'].disclaimer ? (
                      <Row>
                        <Col xs>
                          <p style={{ fontSize: '13px', margin: '0px' }}>
                            <i>
                              {t(
                                props.formElements['form-elements'].disclaimer,
                              )}
                            </i>
                          </p>
                        </Col>
                      </Row>
                    ) : null}
                    <Row style={{ marginTop: '40px' }}>
                      <Col
                        xs
                        style={{
                          alignItems: 'center',
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        <Button disabled={isSubmitting} type="submit">
                          {props.formElements.button
                            ? t(`${props.formElements.button.text}`)
                            : t('portal.forgot_password.submit_button')}
                        </Button>
                      </Col>
                    </Row>
                  </form>
                )}
              </Formik>
            </Styled.Wrap>
          </>
        )}
      </>
    );
  };
  const renderPE = () => {
    if (tag === 'OFFER_PE_SOLUTIONS_1') {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Styled.EmailBoxesContainer>
            {' '}
            <div
              style={{
                background: '#d7f1ff',
                borderRadius: '8px',
                padding: '4px 16px',
              }}
            >
              <p style={{ fontWeight: 600 }}>
                Do you think you may have a leak?
              </p>
              <p style={{ fontSize: '14px' }}>
                Email:{' '}
                <a
                  style={{ color: 'black', fontWeight: 600 }}
                  href="mailto:Water.CustomerCare@PE.Solutions"
                >
                  Water.CustomerCare@PE.Solutions
                </a>
              </p>
              <p style={{ fontSize: '14px' }}>
                Call: <b>0800 849 1342 (Mon-Fri 9am-5pm)</b>
              </p>
            </div>
            <div
              style={{
                background: '#d7f1ff',
                borderRadius: '8px',
                padding: '4px 16px',
              }}
            >
              <p style={{ fontWeight: 600 }}>
                Contact us for support and investigation.
              </p>
              <p style={{ fontSize: '14px' }}>
                Call: <b>Wholesaler Direct (Out of Hours)</b>
              </p>
              <p style={{ fontSize: '14px' }}>
                Visit:{' '}
                <a
                  style={{ color: 'black', fontWeight: 600 }}
                  href="https://pe.solutions/water-emergencies"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  https://pe.solutions/water-emergencies
                </a>
              </p>
            </div>
            <div
              style={{
                background: '#d7f1ff',
                borderRadius: '8px',
                padding: '4px 16px',
              }}
            >
              <p style={{ fontWeight: 600 }}>
                Is your water usage higher than expected for your business type?
              </p>
              <p style={{ fontSize: '14px' }}>
                Speak to us about benchmarking and efficiency advice.
              </p>
              <p style={{ fontSize: '14px' }}>
                Email:{' '}
                <a
                  style={{ color: 'black', fontWeight: 600 }}
                  href="mailto:Water.CustomerCare@PE.Solutions"
                >
                  Water.CustomerCare@PE.Solutions
                </a>
              </p>
              <p style={{ fontSize: '14px' }}>
                Email:{' '}
                <a
                  style={{ color: 'black', fontWeight: 600 }}
                  href="mailto:Sustainability@PE.Solutions"
                >
                  Sustainability@PE.Solutions
                </a>
              </p>
            </div>
            <div
              style={{
                background: '#d7f1ff',
                borderRadius: '8px',
                padding: '4px 16px',
              }}
            >
              <p style={{ fontWeight: 600 }}>
                Have you noticed a recent increase in your water bill?
              </p>
              <p style={{ fontSize: '14px' }}>
                Get in touch to review possible causes and next steps.
              </p>
              <p style={{ fontSize: '14px' }}>
                Email:{' '}
                <a
                  style={{ color: 'black', fontWeight: 600 }}
                  href="mailto:Water.CustomerCare@PE.Solutions"
                >
                  Water.CustomerCare@PE.Solutions
                </a>
              </p>
              <p style={{ fontSize: '14px' }}>
                Visit:{' '}
                <a
                  style={{ color: 'black', fontWeight: 600 }}
                  href="https://pe.solutions/understanding-your-bill/"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  https://pe.solutions/understanding-your-bill/
                </a>
              </p>
            </div>
            <div
              style={{
                background: '#d7f1ff',
                borderRadius: '8px',
                padding: '4px 16px',
              }}
            >
              <p style={{ fontWeight: 600 }}>
                Do you need help understanding your water usage or charges?
              </p>
              <p style={{ fontSize: '14px' }}>
                Contact us for a usage and billing review.
              </p>
              <p style={{ fontSize: '14px' }}>
                Email:{' '}
                <a
                  style={{ color: 'black', fontWeight: 600 }}
                  href="mailto:Water.CustomerCare@PE.Solutions"
                >
                  Water.CustomerCare@PE.Solutions
                </a>
              </p>
              <p style={{ fontSize: '14px' }}>
                Visit:{' '}
                <a
                  style={{ color: 'black', fontWeight: 600 }}
                  href="https://pe.solutions/understanding-your-bill/"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  https://pe.solutions/understanding-your-bill/
                </a>
              </p>
            </div>
          </Styled.EmailBoxesContainer>
        </div>
      );
    } else if (tag === 'OFFER_PE_SOLUTIONS_2') {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Styled.EmailBoxesContainer>
            {' '}
            <div
              style={{
                background: '#d7f1ff',
                borderRadius: '8px',
                padding: '4px 16px',
              }}
            >
              <p style={{ fontWeight: 600 }}>
                Are you using older or inefficient water fixtures?
              </p>
              <p style={{ fontSize: '14px' }}>
                Contact us to explore simple water-saving improvements.
              </p>
              <p style={{ fontSize: '14px' }}>
                Email:{' '}
                <a
                  style={{ color: 'black', fontWeight: 600 }}
                  href="mailto:Water.CustomerCare@PE.Solutions"
                >
                  Water.CustomerCare@PE.Solutions
                </a>
              </p>
              <p style={{ fontSize: '14px' }}>
                Email:{' '}
                <a
                  style={{ color: 'black', fontWeight: 600 }}
                  href="mailto:Sustainability@PE.Solutions"
                >
                  Sustainability@PE.Solutions
                </a>
              </p>
            </div>
            <div
              style={{
                background: '#d7f1ff',
                borderRadius: '8px',
                padding: '4px 16px',
              }}
            >
              <p style={{ fontWeight: 600 }}>
                Would you like advice on reducing water use without impacting
                operations?
              </p>
              <p style={{ fontSize: '14px' }}>
                Speak to us about practical efficiency measures.
              </p>
              <p style={{ fontSize: '14px' }}>
                Email:{' '}
                <a
                  style={{ color: 'black', fontWeight: 600 }}
                  href="mailto:Water.CustomerCare@PE.Solutions"
                >
                  Water.CustomerCare@PE.Solutions
                </a>
              </p>
              <p style={{ fontSize: '14px' }}>
                Email:{' '}
                <a
                  style={{ color: 'black', fontWeight: 600 }}
                  href="mailto:Sustainability@PE.Solutions"
                >
                  Sustainability@PE.Solutions
                </a>
              </p>
            </div>
            <div
              style={{
                background: '#d7f1ff',
                borderRadius: '8px',
                padding: '4px 16px',
              }}
            >
              <p style={{ fontWeight: 600 }}>
                Do you want better visibility or monitoring of your water usage?
              </p>
              <p style={{ fontSize: '14px' }}>
                Contact us to discuss monitoring and data insights.
              </p>
              <p style={{ fontSize: '14px' }}>
                Email:{' '}
                <a
                  style={{ color: 'black', fontWeight: 600 }}
                  href="mailto:Water.CustomerCare@PE.Solutions"
                >
                  Water.CustomerCare@PE.Solutions
                </a>
              </p>
              <p style={{ fontSize: '14px' }}>
                Email:{' '}
                <a
                  style={{ color: 'black', fontWeight: 600 }}
                  href="mailto:Sustainability@PE.Solutions"
                >
                  Sustainability@PE.Solutions
                </a>
              </p>
            </div>
            <div
              style={{
                background: '#d7f1ff',
                borderRadius: '8px',
                padding: '4px 16px',
              }}
            >
              <p style={{ fontWeight: 600 }}>
                Is water efficiency part of your sustainability or ESG
                objectives?
              </p>

              <p style={{ fontSize: '14px' }}>
                Email:{' '}
                <a
                  style={{ color: 'black', fontWeight: 600 }}
                  href="mailto:Sustainability@PE.Solutions"
                >
                  Sustainability@PE.Solutions
                </a>
              </p>
            </div>
            <div
              style={{
                background: '#d7f1ff',
                borderRadius: '8px',
                padding: '4px 16px',
              }}
            >
              <p style={{ fontWeight: 600 }}>
                Would you like support implementing water-saving products or
                measures?
              </p>
              <p style={{ fontSize: '14px' }}>
                Speak to us to understand suitable options.
              </p>
              <p style={{ fontSize: '14px' }}>
                Email:{' '}
                <a
                  style={{ color: 'black', fontWeight: 600 }}
                  href="mailto:Water.CustomerCare@PE.Solutions"
                >
                  Water.CustomerCare@PE.Solutions
                </a>
              </p>
              <p style={{ fontSize: '14px' }}>
                Email:{' '}
                <a
                  style={{ color: 'black', fontWeight: 600 }}
                  href="mailto:Sustainability@PE.Solutions"
                >
                  Sustainability@PE.Solutions
                </a>
              </p>
            </div>
          </Styled.EmailBoxesContainer>
        </div>
      );
    } else if (tag === 'OFFER_PE_SOLUTIONS_3') {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Styled.EmailBoxesContainer>
            {' '}
            <div
              style={{
                background: '#d7f1ff',
                borderRadius: '8px',
                padding: '4px 16px',
              }}
            >
              <p style={{ fontWeight: 600 }}>
                Are you responsible for multiple sites or buildings?
              </p>
              <p style={{ fontSize: '14px' }}>
                We can help you understand and manage water use across your
                portfolio.
              </p>
              <p style={{ fontSize: '14px' }}>
                Email:{' '}
                <a
                  style={{ color: 'black', fontWeight: 600 }}
                  href="mailto:Water.CustomerCare@PE.Solutions"
                >
                  Water.CustomerCare@PE.Solutions
                </a>
              </p>
            </div>
            <div
              style={{
                background: '#d7f1ff',
                borderRadius: '8px',
                padding: '4px 16px',
              }}
            >
              <p style={{ fontWeight: 600 }}>
                Do you want to take further action following your assessment
                results?
              </p>
              <p style={{ fontSize: '14px' }}>
                Get in touch and we can guide you through next steps.
              </p>
              <p style={{ fontSize: '14px' }}>
                Email:{' '}
                <a
                  style={{ color: 'black', fontWeight: 600 }}
                  href="mailto:Water.CustomerCare@PE.Solutions"
                >
                  Water.CustomerCare@PE.Solutions
                </a>
              </p>
              <p style={{ fontSize: '14px' }}>
                Email:{' '}
                <a
                  style={{ color: 'black', fontWeight: 600 }}
                  href="mailto:Sustainability@PE.Solutions"
                >
                  Sustainability@PE.Solutions
                </a>
              </p>
            </div>
            <div
              style={{
                background: '#d7f1ff',
                borderRadius: '8px',
                padding: '4px 16px',
              }}
            >
              <p style={{ fontWeight: 600 }}>
                Are you unsure who is responsible for water within your
                building?
              </p>
              <p style={{ fontSize: '14px' }}>
                Contact us for guidance on landlord and tenant responsibilities.
              </p>
              <p style={{ fontSize: '14px' }}>
                Email:{' '}
                <a href="mailto:Water.CustomerCare@PE.Solutions">
                  Water.CustomerCare@PE.Solutions
                </a>
              </p>
            </div>
          </Styled.EmailBoxesContainer>
        </div>
      );
    } else return renderFormElements();
  };
  return renderPE();
};

export default TaskForm;
